<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>编辑模板</span>
      <el-button
        type="primary"
        size="medium"
        style="width:92px;"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div v-if="tmp_id==1">
          <span style="font-weight:700;margin-right:30px;font-size:16px">默认模板</span>
          <span>注：医生默认绑定此模板，如有特殊需求，可绑定自定义模板</span>
        </div>
        <div v-else>
          <span style="font-weight:700">模板名称</span>
          <el-input
            v-model="tmp_name"
            style="width:200px;margin:0 100px 0 10px"
            maxlength="10"
          ></el-input>
          <span style="font-weight:700">模板备注</span>
          <el-input
            v-model="tmp_remark"
            style="width:200px;margin:0 20px 0 10px"
            maxlength="10"
          ></el-input>
          <el-button
            type="primary"
            @click="addTmpName"
            :disabled="module_id_array[0]? !module_id_array.includes('832'): false"
          >保存</el-button>
        </div>

        <div class="box">
          <div class="dosage">
            <div style="border: solid 1px #c9cbd6;">
              <el-table
                ref="multipleTable"
                :data="drugTypeList"
                tooltip-effect="dark"
                :header-cell-style="{ background: '#F5F5F5' }"
                :row-class-name="tableRowClassName"
                @row-click="changeRow"
              >
                <el-table-column
                  width="60"
                  style="background: '#F5F5F5'"
                >
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.check"
                      @change="(value)=>{return getHospitalList(value,scope.row.drug_type)}"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="drug_type_name"
                  label="剂型名称"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="drug_type_pid_str"
                  label="剂型分类"
                  width="100"
                ></el-table-column>
                <el-table-column
                  label="药房数"
                  width="100"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.hospital_count?scope.row.hospital_count:""}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="排序值"
                  width="130"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      :controls="false"
                      v-model="scope.row.sort"
                      :min="0"
                      :max="999"
                      :precision="0"
                      style="width:80px"
                      size="mini"
                      @blur="changeSort(scope.row.drug_type,scope.row.sort)"
                      :disabled="module_id_array[0]? !module_id_array.includes('834'): false"
                    ></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="hospital">
            <div class="hospitallist">
              <div
                v-for="(item,index) in hospitalList"
                :key="index"
                class="item"
              >
                <el-checkbox
                  style="margin-right:10px"
                  v-model="item.check"
                ></el-checkbox>
                <span>{{item.hospital_name}}</span>
              </div>
            </div>
            <div
              style="text-align:center;margin-top:30px"
              v-if="hospitalList.length"
            >
              <el-button
                type="primary"
                style="width:100px"
                size="medium"
                @click="saveHospital"
                :disabled="module_id_array[0]? !module_id_array.includes('836'): false"
              >保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  data() {
    return {
      tmp_name: this.$route.query.tmp_name ? this.$route.query.tmp_name : '',
      tmp_remark: this.$route.query.tmp_remark
        ? this.$route.query.tmp_remark
        : '',
      tmp_id: this.$route.query.tmp_id ? this.$route.query.tmp_id : '',
      drugTypeList: [],
      hospitalList: [],
      drug_type: '' //选择的剂型
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //新增编辑模板名字
    addTmpName() {
      if (!this.tmp_name) {
        this.$message.error('请填写模板名字');
        return false;
      }
      let data = {
        tmp_name: this.tmp_name,
        tmp_remark: this.tmp_remark,
        tmp_id: this.tmp_id ? this.tmp_id : ''
      };
      this.axios
        .post('platform/Drugtype/savedrugTypeTemplate', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.tmp_id = res.data.tmp_id;
            this.getDrugTypeList();
          }
        });
    },
    //模板剂型列表
    getDrugTypeList() {
      let tmp_id = this.tmp_id;
      this.axios
        .post('platform/Drugtype/drugTypeListTemplate', { tmp_id })
        .then((res) => {
          if (res.code == 0) {
            this.drugTypeList = res.data.list.map((item) => {
              item.check = item.drug_bool ? true : false;
              item.sort = item.sort ? item.sort : undefined;
              return item;
            });
          }
        });
    },
    //每行的样式
    tableRowClassName({ row }) {
      if (row.check) {
        return 'check_row';
      } else {
        return 'notcheck_row';
      }
    },
    //剂型药房列表
    getHospitalList(value, drug_type) {
      if (!value) {
        this.$confirm('确定要取消该剂型药库吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let data = {
              drug_type: drug_type,
              tmp_id: this.tmp_id
            };
            return this.axios
              .post('platform/Drugtype/canceldrugTypeTemplate', data)
              .then((res) => {
                this.$message.success('已取消该剂型药库');
                this.getDrugTypeList();
              })
              .catch(() => {
                this.getDrugTypeList();
              });
          })
          .catch(() => {
            this.getDrugTypeList();
          });
        return false;
      }
      this.drug_type = drug_type;
      let data = {
        drug_type: drug_type,
        tmp_id: this.tmp_id
      };
      this.axios
        .post('platform/Drugtype/templateDrugTypeHospital', data)
        .then((res) => {
          if (res.code == 0) {
            this.hospitalList = res.data.list.map((item) => {
              item.check = item.check_bool ? true : false;
              return item;
            });
          }
        });
    },
    //保存剂型关联药房列表
    saveHospital() {
      let arr = [];
      this.hospitalList.map((item) => {
        if (item.check) {
          arr.push(item.hospital_id);
        }
      });
      let data = {
        drug_type: this.drug_type,
        tmp_id: this.tmp_id,
        hospital_id: arr.length ? arr.toString() : 0
      };
      this.axios
        .post('platform/Drugtype/savetemplateDrugTypeHospital', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.getDrugTypeList();
          }
        });
    },
    //修改剂型排序
    changeSort(drug_type, sort) {
      let data = {
        drug_type,
        sort,
        tmp_id: this.tmp_id
      };
      this.axios
        .post('platform/Drugtype/updateDrugTypeSort', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.getDrugTypeList();
          }
        });
    },
    //点击行
    changeRow(row) {
      this.getHospitalList(true, row.drug_type);
    },
    back() {
      history.back();
    }
  },
  created() {
    if (this.$route.query.tmp_id) {
      this.getDrugTypeList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.box {
  display: flex;
  margin-top: 30px;
  .dosage {
    margin-right: 50px;
    height: calc(100vh - 250px);
    overflow-y: scroll;
  }
  .hospital {
    flex: 1;
    border: solid 1px #c9cbd6;
    height: calc(100vh - 250px);
    overflow-y: scroll;
    padding: 20px;
    box-sizing: border-box;
    .hospitallist {
      display: flex;
      flex-wrap: wrap;
      .item {
        display: flex;
        align-items: center;
        height: 40px;
        width: 50%;
      }
    }
  }
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 80px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.el-table .notcheck_row {
  background: #f7f7f7;
}
.el-table .check_row {
  background: #fff;
}
</style>